export const STORAGE_KEYS = {
  APPLICATION_DATA: '@application_data',
  ORGANIZATION_ID: 'organizationId',
  OTA_LAST_PROMPT_AT: '@ota_last_prompt_at',
  PHOTO_PICKER_CAMERA_DENIED: '@photo_picker_camera_denied',
  PHOTO_PICKER_LIBRARY_DENIED: '@photo_picker_library_denied',
};

export const STORAGE_REDUCERS_TO_SAVE = [
  'auth',
  'organization',
  'deviceFlags',
  'favorites',
  'user',
  'knowledge',
  'fs',
  'notification',
  'owners',
  'lab',
  'admission',
  'communication',
  'labels',
  'workspace',
];

const stripContentFromItem = ({ content, ...item }) => item;

export const STORAGE_REDUCERS_DATA_TO_ELIMINATE = {
  auth: {
    // Transient — persisting it would replay a stale link on a later cold start.
    pendingDeepLink: true,
    // Persisting these would replay the enrollment screen on a cold start.
    suggestBiometricEnrollment: true,
    pendingBiometricEnrollment: true,
    user: {
      web: true,
    },
    token: {
      web: true,
    },
    accessToken: {
      web: true,
    },
    refreshToken: {
      web: true,
    },
  },
  knowledge: {
    items: items => items?.map(stripContentFromItem),
    itemsById: itemsById =>
      Object.fromEntries(
        Object.entries(itemsById || {}).map(([id, item]) => [id, stripContentFromItem(item)]),
      ),
  },
};
